/**
 * Cart Upsell Currency Fix (self-healing version)
 * Fetches the correct price once per card, remembers it,
 * and forcibly restores it any time something else overwrites it.
 */
(function () {
  function extractPriceHTML(doc) {
    var priceEl =
      doc.querySelector('.product-price .price') ||
      doc.querySelector('[data-product-price]') ||
      doc.querySelector('.price');
    return priceEl ? priceEl.outerHTML : null;
  }

  function fetchCorrectPrice(card) {
    var link = card.querySelector('.cart-upsell-img-link');
    if (!link) return;
    var url = link.getAttribute('href');
    if (!url) return;

    fetch(url + (url.includes('?') ? '&' : '?') + '_=' + Date.now(), {
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var priceHTML = extractPriceHTML(doc);
        if (priceHTML) {
          card.dataset.correctPrice = encodeURIComponent(priceHTML);
          applyStoredPrice(card);
        }
      })
      .catch(function (err) {
        console.warn('Price fetch failed for', url, err);
      });
  }

  function applyStoredPrice(card) {
    var priceContainer = card.querySelector('.cart-upsell-prices');
    var stored = card.dataset.correctPrice;
    if (!priceContainer || !stored) return;

    var correctHTML = decodeURIComponent(stored);
    if (priceContainer.innerHTML.trim() !== correctHTML.trim()) {
      priceContainer.__selfHealing = true;
      priceContainer.innerHTML = correctHTML;
      priceContainer.__selfHealing = false;
    }
  }

  function guardCard(card) {
    if (card.__guarded) return;
    card.__guarded = true;

    var priceContainer = card.querySelector('.cart-upsell-prices');
    if (!priceContainer) return;

    fetchCorrectPrice(card);

    var observer = new MutationObserver(function () {
      if (priceContainer.__selfHealing) return; // ignore our own writes
      applyStoredPrice(card); // restore if something else changed it
    });

    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });

    // Extra safety net: re-check every second regardless of mutations
    setInterval(function () { applyStoredPrice(card); }, 1000);
  }

  function scanCards() {
    var container = document.getElementById('cart-upsell-container');
    if (!container) return;
    container.querySelectorAll('.cart-upsell-card').forEach(guardCard);
  }

  function watchForNewCards() {
    var container = document.getElementById('cart-upsell-container');
    if (!container) return;

    scanCards();

    var containerObserver = new MutationObserver(function () {
      scanCards(); // pick up any newly injected cards
    });
    containerObserver.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', watchForNewCards);
  document.addEventListener('cart:updated', watchForNewCards);
  document.addEventListener('cart:refresh', watchForNewCards);
  document.addEventListener('click', function () {
    setTimeout(watchForNewCards, 300);
  });
})();
